import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {ExpandMore} from 'views/icons';
import {Translate} from 'views/module';

const CaseDomainGuide = (props) => {
  const {
    domainGuide,
  } = props;
  const [isOpen, setIsOpen] = React.useState(false);

  const domainGuideText = domainGuide || '';
  const frontmatterMatch = domainGuideText.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n?([\s\S]*)$/);
  const frontmatter = frontmatterMatch ?
    `---\n${frontmatterMatch[1].trim()}\n---` :
    domainGuideText.trim();
  const guideContent = frontmatterMatch ? frontmatterMatch[2].trim() : '';
  const hasGuideContent = Boolean(guideContent);

  const toggleGuide = () => {
    if (!hasGuideContent) {
      return;
    }

    setIsOpen((previousIsOpen) => !previousIsOpen);
  };

  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #E8E4DE',
        borderRadius: '12px',
        overflow: 'hidden',
      }}
    >
      <Box
        component='button'
        onClick={toggleGuide}
        sx={{
          display: 'block',
          width: '100%',
          px: 3,
          py: 2,
          border: 'none',
          backgroundColor: 'transparent',
          cursor: hasGuideContent ? 'pointer' : 'default',
          textAlign: 'left',
        }}
      >
        <Stack direction='row' sx={{alignItems: 'center', justifyContent: 'space-between', gap: 2}}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '11px',
              lineHeight: '14px',
              color: '#A8A49E',
            }}
          >
            <Translate expression='case.Detail.DomainGuide.Title' />
          </Typography>
          {
            hasGuideContent &&
            <ExpandMore
              sx={{
                color: '#A8A49E',
                fontSize: '18px',
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease',
              }}
            />
          }
        </Stack>
      </Box>
      <Stack sx={{gap: 2, px: 3, pb: 2}}>
        <Typography
          component='pre'
          sx={{
            m: 0,
            fontFamily: 'monospace',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '18px',
            color: '#1A1916',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {frontmatter}
        </Typography>
        {
          isOpen && hasGuideContent &&
          <Typography
            component='pre'
            sx={{
              m: 0,
              pt: 2,
              borderTop: '1px solid #E8E4DE',
              fontFamily: 'inherit',
              fontWeight: 400,
              fontSize: '13px',
              lineHeight: '20px',
              color: '#1A1916',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {guideContent}
          </Typography>
        }
      </Stack>
    </Box>
  );
};

CaseDomainGuide.propTypes = {
  domainGuide: PropTypes.string,
};

export default React.memo(CaseDomainGuide);
